var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { useCartMainItem, 
// useCartRequiresShipping,
useCartTotal, useFramePay, useRebilly, } from '../Providers';
import { useEffect, useState } from 'react';
import { Shimmer } from '../UI/Shimmer';
export var DigitalWallet = function () {
    var config = useRebilly();
    var mainItem = useCartMainItem();
    // const shippingAddressRequired = useCartRequiresShipping()
    var totalCost = useCartTotal().totalCost;
    var initialized = useFramePay().initialized;
    var _a = useState(false), mounted = _a[0], setMounted = _a[1];
    var id = 'frame-pay';
    useEffect(function () {
        if (mainItem && initialized) {
            mountFramePay({
                id: id,
                // shippingAddressRequired,
                publishableKey: config.publicKey,
                organizationId: config.organizationId,
                websiteId: config.websiteId,
                label: mainItem.name,
                amount: totalCost,
                onMounted: function () { return setMounted(true); },
            });
        }
    }, [
        id,
        mainItem,
        totalCost,
        initialized,
        // shippingAddressRequired
    ]);
    if (!mainItem)
        return null;
    return _jsx(Mount, __assign({ id: id }, { children: !mounted ? _jsx(Shimmer, { "$isVisible": true }) : null }));
};
function mountFramePay(_a) {
    var id = _a.id, organizationId = _a.organizationId, publishableKey = _a.publishableKey, 
    // shippingAddressRequired,
    websiteId = _a.websiteId, _b = _a.currency, currency = _b === void 0 ? 'USD' : _b, amount = _a.amount, label = _a.label, onMounted = _a.onMounted;
    var isApplePayEnabled = !!window['ApplePaySession'];
    if (typeof window.Rebilly === 'undefined')
        return;
    window.Rebilly.initialize({
        organizationId: organizationId,
        publishableKey: publishableKey,
        websiteId: websiteId,
        googlePay: {
            buttonType: 'short',
            shippingAddressRequired: true,
            emailRequired: true,
        },
        transactionData: {
            amount: amount,
            currency: currency,
            label: label,
        },
    });
    window.Rebilly.on('ready', function () {
        if (isApplePayEnabled) {
            window.Rebilly.applePay.mount("#".concat(id));
        }
        else {
            window.Rebilly.googlePay.mount("#".concat(id));
        }
        if (onMounted) {
            onMounted();
        }
    });
}
var Mount = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  --button-shimmer-color: rgba(0, 0, 0, 0.5);\n  --shimmer-width: 100%;\n  --shimmer-duration: 2s;\n  --min-height: 50px;\n\n  position: relative;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: calc(var(--spacing) * 2);\n  min-height: var(--min-height);\n  background-color: rgba(0, 0, 0, 0.1);\n\n  #rebilly-apple-pay-button {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    margin: 0;\n  }\n"], ["\n  --button-shimmer-color: rgba(0, 0, 0, 0.5);\n  --shimmer-width: 100%;\n  --shimmer-duration: 2s;\n  --min-height: 50px;\n\n  position: relative;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: calc(var(--spacing) * 2);\n  min-height: var(--min-height);\n  background-color: rgba(0, 0, 0, 0.1);\n\n  #rebilly-apple-pay-button {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    margin: 0;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=DigitalWallet.js.map